var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":"Odběrná místa"}}),_c('SupplyPointMobileList',{staticClass:"mb-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }